import type {Refractory} from '../types'

export const isRefractoryDeleted = (refractory: Pick<Refractory, 'status'>): boolean =>
  refractory.status === 'Deleted'
